module.exports = __webpack_public_path__ + "fonts/SFUIText-LightItalic.53b2ca67.woff";